import { icons } from '../utils/icons';

export const skills = [
	{
		id: 1,
		name: 'HTML',
		info: 'Proficient in writing clean, semantic HTML code and creating well-structured website layouts. Experienced in using HTML to implement responsive designs, optimize for search engines (SEO), and enhance accessibility. Skilled in integrating HTML with CSS and JavaScript to develop interactive and dynamic web pages.',
		icon: icons.html,
	},
	{
		id: 2,
		name: 'CSS',
		info: 'Proficient in writing efficient CSS code and creating visually appealing and responsive designs. Skilled in utilizing CSS frameworks like Bootstrap and preprocessors like SASS to streamline development workflows. Experienced in implementing animations, transitions, and optimizing stylesheets for performance.',
		icon: icons.css,
	},
	{
		id: 3,
		name: 'Bootstrap',
		info: "Proficient in utilizing the Bootstrap framework to create responsive and mobile-first websites. Skilled in leveraging Bootstrap's grid system, components, and utilities to streamline development and ensure consistent styling across different devices. Experienced in customizing and extending Bootstrap to meet specific project requirements.",
		icon: icons.bootstrap,
	},
	{
		id: 4,
		name: 'Material-UI (MUI)',
		info: 'Experienced in designing modern and responsive web applications using Material-UI. Proficient in leveraging Material-UI components, theming, and styling solutions for consistent and accessible designs. Skilled in customizing Material-UI to meet unique project requirements.',
		icon: icons.mui,
	},
	{
		id: 5,
		name: 'JavaScript',
		info: 'Strong command of JavaScript for creating dynamic user interfaces and handling DOM manipulation. Experienced in implementing API calls, creating interactive animations, and writing clean, efficient code for web applications.',
		icon: icons.javascript,
	},
	{
		id: 6,
		name: 'React.js',
		info: 'Experienced in building complex applications using React.js and its ecosystem. Proficient in designing reusable components, managing state and props, and utilizing React Router for efficient navigation. Skilled in integrating external libraries, handling form inputs, and optimizing React applications for speed and performance.',
		icon: icons.react,
	},
	{
		id: 7,
		name: 'Redux',
		info: 'Experienced in utilizing Redux for state management in complex JavaScript applications. Proficient in setting up Redux stores, defining actions, reducers, and connecting components. Skilled in managing application state, handling asynchronous operations with middleware, and optimizing Redux architecture.',
		icon: icons.redux,
	},
	{
		id: 8,
		name: 'Node.js',
		info: 'Proficient in building server-side applications using Node.js. Experienced in creating RESTful APIs, handling asynchronous programming, and integrating databases. Skilled in utilizing Node.js for efficient backend development and real-time communication.',
		icon: icons.node,
	},
	{
		id: 9,
		name: 'Express.js',
		info: 'Experienced in creating scalable and efficient backend systems using Express.js. Proficient in routing, middleware integration, and API development. Skilled in handling authentication, authorization, and error handling within Express.js applications.',
		icon: icons.express,
	},
	{
		id: 10,
		name: 'REST APIs',
		info: 'Experienced in designing and implementing RESTful APIs for web applications. Proficient in handling CRUD operations, securing APIs, and ensuring efficient communication between frontend and backend. Skilled in API documentation and versioning.',
		icon: icons.restapi,
	},
	{
		id: 11,
		name: 'MongoDB',
		info: 'Proficient in using MongoDB as a NoSQL database for scalable and flexible data storage. Experienced in designing schemas, managing collections, and optimizing queries for performance. Skilled in integrating MongoDB with Node.js applications using libraries like Mongoose.',
		icon: icons.mongodb,
	},
	
	
	{
		id: 12,
		name: 'Git',
		info: 'Proficient in utilizing Git for version control and collaboration. Skilled in managing repositories, branching, merging, and resolving conflicts. Experienced in leveraging GitHub for project hosting, issue tracking, and contributing to open-source projects. Knowledgeable in Git workflows, including feature branching and pull request-based development.',
		icon: icons.git,
	},
];
